import { Button, Divider, Grid } from '@mui/material';
import { isString, merge, set } from 'lodash';
import type { Path } from 'react-hook-form';
import { BackSoonAccordionPanel } from 'src/components/widget/lineupWidget/editProductPanel/components/backSoon/BackSoon';
import { ProductImageWidget } from 'src/components/widget/productImageWidget';
import type { IGcfBadge } from 'src/interfaces';
import { lang } from 'src/utils';

import { ComboStyleImageBadge } from '../comboStyleImageBadge/ComboStyleImageBadge';
import { ComboStyleVisualsProps } from './ComboStyleVisuals.interface';

export const ComboStyleVisuals = (props: ComboStyleVisualsProps) => {
  const handleOnChange =
    (field?: Path<ComboStyleVisualsProps['asset']>) =>
    (value: unknown, fieldDetails?: any) => {
      if (field) {
        props.handleAssetChange(
          set(
            { ...props.asset },
            isString(fieldDetails) ? `${field}.${fieldDetails}` : field,
            value,
          ),
        );
      } else {
        props.handleAssetChange(merge(props.asset, value));
      }
    };

  const badgeValue = {
    ...props.asset.badge,
    visible: props.asset?.badge?.visible || props.componentImageBadge?.visible,
    style: {
      ...props.currentTheme?.config.badges?.imageBadge,
      ...props.componentImageBadge?.style,
      ...props.asset.badge?.style,
      fontColor:
        props.asset.badge?.style?.fontColor ??
        props.componentImageBadge?.style?.color ??
        props.currentTheme?.config.badges?.imageBadge?.color,
      badgeSize:
        props.asset.badge?.style?.badgeSize ??
        props.componentImageBadge?.style?.size ??
        props.currentTheme?.config.badges?.imageBadge?.size,
    },
  } as IGcfBadge;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ProductImageWidget
          value={props.asset}
          fallbackImgSrc={props.fallbackAssets[0]?.name}
          option={{
            showZIndex: true,
            showProductImageController: true,
            enableSelectProductImage:
              props.showComponents.enableSelectProductImages,
            enableUploadProductImages:
              props.showComponents.enableUploadProductImages,
            hideProductLabel: true,
          }}
          onChange={handleOnChange()}
          product={props.currentProduct}
          hasSupportingProduct={props.hasSupportingProduct}
        />
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <ComboStyleImageBadge
          badge={badgeValue}
          handleOnChange={handleOnChange('badge')}
        />
      </Grid>

      {!props.isBackupProduct && (
        <>
          <Grid item xs={12}>
            <BackSoonAccordionPanel
              product={props.currentProduct}
              outageStamp={props.asset.outageStamp}
              onChange={handleOnChange('outageStamp')}
              onChangeBackSoonActive={props.onChangeGCFProductStatus}
              supportingProductCode={props.asset.productCode}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <Button
          variant="outlined"
          disabled={!props.isImageDeletable}
          onClick={props.onRemoveVisualSource}>
          {lang.removeImage}
        </Button>
      </Grid>
    </Grid>
  );
};
